import { createContext, useContext } from "react"

/**
 * Element that Radix portals (dialog, popover, dropdown, tooltip, select)
 * mount into.
 *
 * Radix defaults every portal to `document.body` — resolved against the
 * *module's* `document`, i.e. the main window. That is correct everywhere
 * except inside a React portal rendered into a SECOND browser window (the
 * recap chat panel's pop-out): overlays opened from that window would appear
 * on the opener's screen, detached from the control that opened them.
 *
 * `null` (the default) means "let each primitive use its own default", so
 * every existing call site is unaffected.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null)

/**
 * Container to hand Radix's `<Portal container>`. Returns `undefined` when no
 * provider is mounted so the primitive keeps its own default.
 */
export function usePortalContainer(): HTMLElement | undefined {
  return useContext(PortalContainerContext) ?? undefined
}
